module.exports = __webpack_public_path__ + "assets/img/board-thumbnail.cd1c1f8b.png";